export class TimeAverage {
    private entries: { timestamp: number; value: number }[] = []
    private readonly windowMs: number
    private sum: number = 0

    constructor(windowSeconds: number) {
        if (windowSeconds <= 0) {
            throw new Error('Time window must be positive.')
        }
        this.windowMs = windowSeconds * 1000
    }

    add(value: number): void {
        const now = Date.now()
        this.entries.push({ timestamp: now, value })
        this.sum += value
        this.prune(now)
    }

    private prune(currentTime: number): void {
        const cutoff = currentTime - this.windowMs
        while (this.entries.length > 0 && this.entries[0].timestamp < cutoff) {
            const removedEntry = this.entries.shift()
            if (removedEntry) {
                this.sum -= removedEntry.value
            }
        }
    }

    getAverage(): number {
        const now = Date.now()
        this.prune(now) // Ensure entries are current before calculating average
        if (this.entries.length === 0) return 0
        return this.sum / this.entries.length
    }

    reset(): void {
        this.entries = []
        this.sum = 0
    }
}
